import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const Lightning = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
  >
    <Path
      color={color}
      d="M7 2.45117V13.4512H10V22.4512L17 10.4512H13L17 2.45117H7Z"
    />
  </svg>
);
